import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TableCell, TableRow } from '@material-ui/core';
import { convertTimeWithTimezone } from '../../../../utils/time';
import { OsrPhoneAssociatedCampaign } from '../../types';
import { formatUSPhoneNumber, normalizePhoneNumber } from '@/utils/phone';
import { BoxV2 as Box, Flex } from 'portal-commons';

interface Props {
  data: OsrPhoneAssociatedCampaign;
}

const NumbersProvisionedListingRow: React.FC<Props> = (props) => {
  const { data } = props;
  const history = useHistory();
  const [phoneCopied, setPhoneCopied] = useState(false);

  const handleCopy = (number: string) => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(number);
      setPhoneCopied(true);
      setTimeout(() => {
        setPhoneCopied(false);
      }, 1000);
    }
  };

  const handlePhoneRedirect = (e: React.MouseEvent) => {
    e.preventDefault();
    const normalizedPhone = normalizePhoneNumber(data.phoneNumber);
    history.push(`/phones/${normalizedPhone}`);
  };

  return (
    <TableRow data-testid="numbersProvisionedListingRow">
      <TableCell align="left" data-testid="phoneNumber">
        <Flex sx={{ alignItems: 'baseline' }}>
          <Box
            as="span"
            onClick={handlePhoneRedirect}
            data-testid="phoneNumberLink"
            sx={{
              cursor: 'pointer',
              color: '#0091B3',
              fontSize: 'H200',
              fontWeight: 400,
            }}
          >
            {formatUSPhoneNumber(data.phoneNumber)}
          </Box>
          <Box
            as="span"
            onClick={() => handleCopy(formatUSPhoneNumber(data.phoneNumber))}
            data-testid="copyPhoneNumberButton"
            sx={{
              cursor: 'pointer',
              marginLeft: '5px',
              color: phoneCopied ? '#49535D' : '#B3B7BB',
              fontSize: '10px',
              fontWeight: 400,
              lineHeight: 'normal',
              textDecorationLine: 'underline',
              transition: phoneCopied ? '1s' : undefined,
            }}
          >
            {phoneCopied ? 'copied' : 'copy'}
          </Box>
        </Flex>
      </TableCell>
      <TableCell align="left" data-testid="nnid">
        {data.nnid ? data.nnid : ''}
      </TableCell>
      <TableCell align="left" data-testid="provisionedOn">
        {data.startTimestamp
          ? convertTimeWithTimezone(data.startTimestamp)
          : ''}
      </TableCell>
    </TableRow>
  );
};

export default NumbersProvisionedListingRow;
